"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVER_AUTH_ALLOWED_AMPLIFY_AUTH_KEY_SUFFIX = exports.ENFORCED_SERVER_SIDE_AUTH_SET_COOKIE_OPTIONS = exports.DEFAULT_SERVER_SIDE_AUTH_SET_COOKIE_OPTIONS = exports.SIGN_IN_TIMEOUT_ERROR_MESSAGE = exports.SIGN_IN_TIMEOUT_ERROR_CODE = exports.OAUTH_GRANT_TYPE = exports.REMOVE_COOKIE_MAX_AGE = exports.AUTH_FLOW_PROOF_MAX_AGE = exports.IS_SIGNING_OUT_REDIRECTING_COOKIE_NAME = exports.IS_SIGNING_OUT_COOKIE_NAME = exports.STATE_COOKIE_NAME = exports.PKCE_COOKIE_NAME = exports.COGNITO_IDENTITY_PROVIDERS = exports.SUPPORTED_ROUTES = void 0;
exports.SUPPORTED_ROUTES = [
    'sign-in',
    'sign-in-callback',
    'sign-up',
    'sign-out',
    'sign-out-callback',
];
exports.COGNITO_IDENTITY_PROVIDERS = {
    Google: 'Google',
    Facebook: 'Facebook',
    Amazon: 'LoginWithAmazon',
    Apple: 'SignInWithApple',
};
exports.PKCE_COOKIE_NAME = 'com.amplify.server_auth.pkce';
exports.STATE_COOKIE_NAME = 'com.amplify.server_auth.state';
exports.IS_SIGNING_OUT_COOKIE_NAME = 'com.amplify.server_auth.isSigningOut';
exports.IS_SIGNING_OUT_REDIRECTING_COOKIE_NAME = 'com.amplify.server_auth.isSigningOutRedirecting';
// The 5 minutes is from the Cognito Social Identity Provider settings, see:
// https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-user-pools-social-idp.html
exports.AUTH_FLOW_PROOF_MAX_AGE = 5 * 60;
// -1 to remove the cookie immediately (0 ==> session cookie as observed)
exports.REMOVE_COOKIE_MAX_AGE = -1;
// With server-side auth flow, we don't support the less secure implicit flow
exports.OAUTH_GRANT_TYPE = 'authorization_code';
exports.SIGN_IN_TIMEOUT_ERROR_CODE = 'timeout';
exports.SIGN_IN_TIMEOUT_ERROR_MESSAGE = 'Sign in has to be completed within 5 minutes.';
exports.DEFAULT_SERVER_SIDE_AUTH_SET_COOKIE_OPTIONS = {
    sameSite: 'strict',
};
exports.ENFORCED_SERVER_SIDE_AUTH_SET_COOKIE_OPTIONS = {
    httpOnly: true,
};
exports.SERVER_AUTH_ALLOWED_AMPLIFY_AUTH_KEY_SUFFIX = [
    '.accessToken',
    '.idToken',
    '.refreshToken',
    '.LastAuthUser',
];
